import { Sounds } from "../../types/Enum";
import { ButtonBounds } from "../../types/Interface";
import BaseButton from "./BaseButton";


export default class ManuelExplodeButton extends BaseButton {
  constructor(Bounds: ButtonBounds) {
    super("manuel_explode", Sounds.click2, false);
    Object.assign(this, Bounds);

    this.on("mouseup", () => this.handleMouseUp());
    this.on("touchend", () => this.handleMouseUp());
    this.EventBus.on(this.EnumEventBus.setTgleMlAndAutoBut, v => this.setVisible(!Boolean(v)))
  }
  handlePress(): void {
    this.EventBus.emit(this.EnumEventBus.setManuelExplode, true);
  }
  handleMouseUp() {
    this.EventBus.emit(this.EnumEventBus.setTgleMlAndAutoBut, true);
  }
  setVisible(v: boolean) {
    this.visible = v;
  }
}
